/* eslint-disable no-console */
export const logger = {
  warn(...args) {
    if (process.env.NODE_ENV !== 'production') console.warn(...args);
  },
  error(...args) {
    if (process.env.NODE_ENV !== 'production') console.error(...args);
  },
  info(...args) {
    if (process.env.NODE_ENV !== 'production') console.info(...args);
  },
};
